import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './dark-theme-colors.css';
import './styles.css';
import App from './App';
import { initializeTheme } from './utils/theme';

if (process.env.NODE_ENV === 'development') {
  const resizeObserverMessages = [
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
  ];

  const shouldIgnoreResizeObserverError = (message = '') =>
    resizeObserverMessages.some((knownMessage) => message.includes(knownMessage));

  window.addEventListener('error', (event) => {
    if (shouldIgnoreResizeObserverError(event.message)) {
      event.stopImmediatePropagation();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reasonMessage =
      typeof event.reason === 'string'
        ? event.reason
        : event.reason?.message || '';

    if (shouldIgnoreResizeObserverError(reasonMessage)) {
      event.preventDefault();
    }
  });
}

initializeTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);
